// import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

(() => {
  const tags = document.querySelector(".filtered-reviews__tags");
  const wrapper = document.querySelector(".filtered-reviews__wrapper");
  const swippers = document.querySelectorAll(".filtered-reviews__swiper");
  const swippersWrapper = document.querySelector(".filtered-reviews__content");
  const navigationWrapper = document.querySelector(
    ".filtered-reviews__buttons-wrapper"
  );
  const navigationButtons = document.querySelectorAll(
    ".filtered-reviews__buttons"
  );

  tags.addEventListener("click", toggleTag);
  function toggleTag(e) {
    const closest = e.target.closest("li");
    if (closest.classList.contains("active")) {
      return;
    }

    swippersWrapper.classList.add("blur");
    navigationWrapper.classList.add("blur");

    const activeTag = wrapper.dataset.active;

    if (activeTag) {
      const activeLi = e.currentTarget.querySelector(
        `li[data-tag="${activeTag}"]`
      );
      activeLi.classList.remove("active");
      const swp = findSwipper(activeTag);
      const btn = findButtons(activeTag);
      btn.style.display = "none";
      swp.style.display = "none";
    }

    const newActiveTag = closest.dataset.tag;
    const swp = findSwipper(newActiveTag);
    const btn = findButtons(newActiveTag);

    wrapper.dataset.active = newActiveTag;
    closest.classList.add("active");
    swp.swiper.slideTo(0);
    swp.style.display = "block";
    btn.style.display = "flex";

    setTimeout(() => {
      swippersWrapper.classList.remove("blur");
      navigationWrapper.classList.remove("blur");
    });
  }

  function findSwipper(tag) {
    return Array.from(swippers).find((sw) => sw.dataset.tag === tag);
  }
  function findButtons(tag) {
    return Array.from(navigationButtons).find((sw) => sw.dataset.tag === tag);
  }

  swippers.forEach((swipper) => {
    const tag = swipper.dataset.tag;
    const buttons = findButtons(tag);
    const nextEl = buttons.querySelector(
      ".filtered-reviews__swiper-button-next"
    );
    const prevEl = buttons.querySelector(
      ".filtered-reviews__swiper-button-prev"
    );
    const swiper = new Swiper(swipper, {
      slidesPerView: "auto",
      spaceBetween: 19,
      grabCursor: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  });
})();
